import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Notification clicks sent by the service worker to an open window. Handled at router level, so
 * they work on every page; protected routes keep the target through login.
 */
export const useServiceWorkerNavigation = (): void => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const handler = (event: MessageEvent) => {
      const data = event.data;
      if (!data || data.type !== "NAVIGATE" || typeof data.route !== "string") return;
      if (!data.route.startsWith("/") || data.route.startsWith("//")) return;

      navigate(data.route);
    };

    navigator.serviceWorker.addEventListener("message", handler);
    return () => navigator.serviceWorker.removeEventListener("message", handler);
  }, [navigate]);
};
